import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useLang } from "../i18n";

export default function Reviews({ content }) {
  const { t, lang } = useLang();
  const reviews = content.reviews || [];
  if (reviews.length === 0) return null;

  return (
    <section id="reviews" className="relative z-10 bg-[#050505] py-24 sm:py-32 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="mb-14 max-w-2xl">
          <div className="font-mono2 text-xs uppercase tracking-[0.3em] text-primary-red mb-4">/ {t.reviews.kicker}</div>
          <h2 className="font-display uppercase text-4xl sm:text-6xl text-white leading-[0.95]">{t.reviews.title}</h2>
          <p className="mt-5 font-body text-lg text-neutral-400">{t.reviews.sub}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          {reviews.map((r, i) => (
            <motion.div
              key={r.id || i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="border border-white/10 p-7 flex flex-col hover:border-primary-red/50 transition-colors"
              data-testid={`review-${i}`}
            >
              <Quote size={32} className="text-primary-red mb-4" />
              <div className="flex gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={16} className={s < (r.rating || 5) ? "fill-[#E10600] text-[#E10600]" : "text-neutral-700"} />
                ))}
              </div>
              <p className="font-body text-neutral-200 leading-relaxed flex-1">
                “{lang === "en" ? r.quote_en : r.quote_es}”
              </p>
              <div className="mt-6 pt-5 border-t border-white/10">
                <div className="font-display uppercase text-xl text-white leading-none">{r.name}</div>
                {r.location && <div className="font-body text-sm text-neutral-500 mt-1">{r.location}</div>}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
